import { render, staticRenderFns } from "./feed-list.vue?vue&type=template&id=ae47e97a&scoped=true&"
import script from "./feed-list.vue?vue&type=script&lang=js&"
export * from "./feed-list.vue?vue&type=script&lang=js&"
import style0 from "./feed-list.vue?vue&type=style&index=0&id=ae47e97a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae47e97a",
  null
  
)

export default component.exports